import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import flowerNew from '../../../../../assets/images/reg-guide/flower-new.png';
import flower from '../../../../../assets/images/reg-guide/flower.png';

export const useStyles = makeStyles(({
  fontFamilies,
  palette,
  fontSizes,
  fontWeights,
  breakpoints,
}: Theme) => ({
  dark: {
    background: palette.primary.dark,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1.5rem',
    width: '100%',
    height: '100%',
    padding: '1.5rem 0.675rem 2rem',
    [breakpoints.up('sm')]: {
      marginTop: '2.5rem',
    },
  },
  title: {
    lineHeight: 1.3,
    margin: 0,
    textAlign: 'center',
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.xxl,
    fontWeight: fontWeights.medium,
    '& sup': {
      position: 'relative',
      lineHeight: 0,
    },
    '& span': {
      display: 'inline-block',
    },
  },
  textLight: {
    color: palette.common.white,
  },
  textDark: {
    color: palette.primary.dark,
  },
  description: {
    margin: 0,
    fontSize: fontSizes.lg,
    lineHeight: 1.35,
    textAlign: 'center',
  },
  button: {
    '&&': {
      width: '20rem',
      maxWidth: '100%',
      borderRadius: '2rem',
      '&.light': {
        padding: '0.675rem 1.25rem',
        border: `2px solid ${palette.common.white}`,
        backgroundColor: palette.primary.main,
      },
      '&.white': {
        borderColor: palette.primary.main,
      },
    },
    '&:focus-visible': {
      outline: `1px solid ${palette.primary.dark}`,
      outlineOffset: 2,
    },
  },
  buttonText: {
    fontSize: fontSizes.xl,
    '&.light': {
      color: palette.common.white,
    },
  },
  childButton: {
    '&&': {
      color: '#003E83',
    },
  },
  img: {
    height: 239,
    background: `no-repeat url(${flower}) bottom right`,
    backgroundSize: 'contain',
  },

  imgNew: {
    height: 239,
    background: `no-repeat url(${flowerNew}) bottom right`,
    backgroundSize: 'contain',
  },
}));
